export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=708c1f8dbbc1faf76aa481281f7675c95c749cd34e&name=pushAdClickData!'